/**
 * Determines if search engine indexing should be allowed based on domain and environment.
 *
 * Allowlist of exact hostnames permitted for indexing in production.
 * Uses exact matching to prevent substring attacks (e.g., fake-myusapassport.com).
 *
 * @param host - The hostname from request headers
 * @returns true if indexing is allowed (exact match in production), false otherwise
 */
export function shouldAllowIndexing(host: string): boolean {
  const isProd = process.env.NEXT_PUBLIC_ENV === "prod";

  // Exact hostname allowlist for production indexing
  const allowedHosts = ["myusapassport.com", "www.myusapassport.com"];

  // Normalize host: remove port if present, convert to lowercase
  const normalizedHost = host.split(":")[0].toLowerCase();

  // Allow indexing only for exact hostname matches in production
  return allowedHosts.includes(normalizedHost) && isProd;
}
